import {Work} from "./work.js";
import {Book} from "./book.js";
import {Challenger} from "./challenger.js";

export class Challenge {
    constructor(id, name, startDate, endDate, work, challengers) {
        this.id = id;
        this.name = name;
        this.startDate = startDate;
        this.endDate = endDate;
        this.work = work;
        this.challengers = challengers;
    }

    static from_json(json) {
        const work = Work.from_json(json.work);
        const challengers = [];
        json.challengers.forEach(challenger => challengers.push(Challenger.from_json(challenger)));
        return new Challenge(json.serverId, json.name, json.startDate, json.endDate, work, challengers);
    }

    get_id() {
        return this.id;
    }

    get_name() {
        return this.name;
    }

    get_start_date() {
        return this.startDate;
    }

    get_end_date() {
        return this.endDate;
    }

    get_work() {
        return this.work;
    }

    get_challengers() {
        return this.challengers;
    }
}